import React, { useContext } from 'react'
import Reports from './Reports'
import { AppContext } from '../../../global'
import * as actions from '../store/actions'
import { useParams } from 'react-router-dom'
import { Params } from '../../../modules/types'

function ReportsRoute() {
  const { state, execute } = useContext(AppContext)
  const { partnerId } = useParams() as Params

  async function loadReports() {
    await execute(actions.loadReports())
  }

  return (
    <Reports partnerId={partnerId} state={state.reports} loadReports={loadReports} />
  )
}

export default ReportsRoute
